<template>
  <div class="mb-3">
    <Loader :loading="httpSend">
      <div class="row">
        <div class="col-md-12">
          <div class="row">
            <h5 class="mb-3">Dados do Solicitante</h5>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-3">
          <label>CPF</label>
          <h5>{{ solicitante.pes_cpfcnpj | VMask('###.###.###-##') }}</h5>
        </div>
        <div class="col-md-5">
          <label>Nome</label>
          <h5>{{ solicitante.pes_nome }}</h5>
        </div>
        <div class="col-md-4">
          <label>E-mail</label>
          <h5>{{ solicitante.pes_mail }}</h5>
        </div>
      </div>
    </Loader>
  </div>
</template>
<script>

import Loader from "@/components/widgets/loader";

export default {
  components: {
    Loader,
  },
  data() {
    return {
      solicitante: {
        pes_cpfcnpj: null,
        pes_nome: null,
        pes_mail: null
      },
      httpSend: false,
    };
  },
  created() {
    this.solicitante = this.$store.state.auth.currentUser;
  },
};
</script>
<style>

input[type="text"][disabled] {
  background-color: #f6f6f9;
}

.option__title {
  word-wrap: break-word;
  white-space: normal;
}
</style>